import Image from 'next/legacy/image'
import { Trans, useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import Map from '@/components/maplibre-map/map'
import MapStyler from '@/components/maplibre-map/map/map-styler'
import Marker from '@/components/maplibre-map/marker'

import markerIcon from './images/map-marker.png'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 60px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 10px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;

  :nth-child(2) {
    margin: 0 100px;

    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      margin: 0;
    }
  }
`

const SubTitle = styled.h3`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  font-size: 18px;
  font-weight: bold;
  letter-spacing: -0.2px;
  line-height: 24px;
  text-align: center;
  margin: 0 0 5px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    letter-spacing: -0.5px;
    text-align: left;
    margin-bottom: 0px;
  }
`

const StyledParagraph = styled.p`
  margin: 0 0 20px;
  margin-bottom: 20px;
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 24px;
  text-align: center;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    line-height: 19px;
    font-size: 14px;
    text-align: left;
  }
`

const MapContent = styled.div`
  flex: 2;
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    height: 400px;
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    height: 300px;
  }
`

const MapWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1150px;
  border-radius: 10px;
  overflow: hidden;
`

const Link = styled(props => <StyledParagraph {...props} as="a" />)`
  text-decoration: none;
  color: ${colors.regular};
`

const MarkerWrapper = styled.div`
  position: absolute;
  top: -12px;
  left: 0px;
  width: 25px;
  height: 25px;
`

const COORDS: [number, number] = [49.2924997, -123.1294391]

const MarkerComponent = () => (
  <MarkerWrapper>
    <Image src={markerIcon} width={25} height={25} alt="" loading="eager" />
  </MarkerWrapper>
)

const MapSection = () => (
  <MapStyler>
    <MapContent>
      <MapWrapper>
        <Map center={COORDS} zoom={14}>
          <Marker position={COORDS} IconComponent={MarkerComponent} />
        </Map>
      </MapWrapper>
    </MapContent>
  </MapStyler>
)

const ContactUs = () => {
  const { t } = useTranslation('about')
  return (
    <>
      <ContentWrapper>
        <Content>
          <SubTitle>{t("about:We're available")}</SubTitle>
          <StyledParagraph>
            <Trans i18nKey="about:availability">
              Mon-Fri 9 a.m. - 5 p.m. PST
              <br />
              Sat 11 a.m. - 4 p.m. PST
              <br />
            </Trans>
          </StyledParagraph>
        </Content>
        <Content>
          <SubTitle>{t('about:Head office')}</SubTitle>
          <StyledParagraph>
            <Trans i18nKey="about:address">
              Suite 1A - 1601 Bayshore Dr.
              <br />
              Vancouver, BC V6G 2V4
              <br />
            </Trans>
          </StyledParagraph>
        </Content>
        <Content>
          <SubTitle>{t('about:Reach us by')}</SubTitle>
          <StyledParagraph>
            <Trans i18nKey="about:contact_info">
              <Link href="mailto:info@liv.rent">info@liv.rent</Link>
              <br />
            </Trans>
          </StyledParagraph>
        </Content>
      </ContentWrapper>
      <MapSection />
    </>
  )
}

export default ContactUs
